<template>
  <div>
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div class="e-mtavr-15" >რეგისტრირებული მოთხოვნები </div>
      <!-- <button class="btn btn-primary" @click="refreshToken">a</button> -->
    </h4>
    <!-- <button class="btn btn-primary" @click="dcrs()">გამოაკელი</button> -->
    <div class="row">
      <div class="col-md-12 col-lg-12 col-sm-12 col-xl-12">
        <server-side v-if="ServerSideOnly"></server-side>
        <registered-requests v-if="!ServerSideOnly && !isinvestigating" @ChangeStatus="isinvestigating = true"></registered-requests>
        <investigating-request v-else :isinvestigating="!ServerSideOnly && isinvestigating" @ChangeStatus="isinvestigating = false"></investigating-request>
      </div>
    </div>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import registeredRequests from './registeredrequests'
import serverSide from './serverSideRequests'
// import investigatingRequest from './investigatingrequest'
import { store } from '../../../backend/vuex-storage/globalStoreParameters'
export default {
  components: {
    serverSide,
    registeredRequests
    // investigatingRequest
  },
  data () {
    return {
      isinvestigating: this.$store.getters.getInvestigationStatus,
      investigatingRequest: this.$store.getters.getInvestigatingRequestData
    }
  },
  methods: {
    // dcrs () {
    //   this.$store.commit('DCRSsearches')
    // },
    refreshToken () {
      const RefreshTokenVal = { token: store.getters.getRefreshToken }
      BaseService.RefreshJWTToken(RefreshTokenVal)
        .then(res => {
          store.commit('setJWTTokenItem', res.data.result)
        })
    }
  },
  computed: {
    user () {
      return this.$store.state.authentication.user
    },
    users () {
      return this.$store.state.users.all
    }
  },
  created () {
    this.$store.dispatch('users/getAll')
    this.$store.dispatch('ClearOperData')
    this.isinvestigating = false
    this.ServerSideOnly = false
  }
}
</script>
